class ReconnectController {
    constructor($scope, $log, $location, $timeout, connectionService) {
        const RECONNECT_TIMEOUT_IN_MILLISECONDS = 600000;   // 10 min

        this.timeoutPromise = null;
        this.$scope = $scope;
        this.$log = $log;
        this.$location = $location;
        this.connectionService = connectionService;
        this.isReconnecting = false;

        $scope.$on('isReconnecting', (event, isReconnecting) => {
            this.isReconnecting = isReconnecting;
            
            if(this.timeoutPromise) {
                $timeout.cancel(this.timeoutPromise);
            }

            if (isReconnecting) {
                this.timeoutPromise = $timeout(() => this.cancel(), RECONNECT_TIMEOUT_IN_MILLISECONDS);
            }
        });
    }

    cancel() {
        this.isReconnecting = false;
        this.connectionService.cancelReconnect();
    }
}

angular.module('webcomm')
    .directive('reconnect', function () {
        return {
            templateUrl: 'app/main/reconnect/reconnect.html',
            replace: true,
            controller: 'ReconnectController',
            controllerAs: 'reconnect'
        };
    })
    .controller('ReconnectController', ['$scope', '$log', '$location', '$timeout', 'connectionService', ReconnectController]);
